// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"697":"335a7dea212ace55","723":"b9f629966ebceffd"}[chunkId] + ".js";
};